/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum SlaGraphicAliases {
  AUTOCOMPLETE_MONTH = 'autocomplete-month',
  AUTOCOMPLETE_TIME_COURSE = 'autocomplete-time-course',
  AUTOCOMPLETE_YEAR = 'autocomplete-year',
  CONTEXTUAL_BAR_MONTH = 'contextual-bar-month',
  CONTEXTUAL_BAR_RESOLUTION_TIME = 'contextual-bar-resolution-time',
  FETCH_MONTH = 'fetch-month',
  FETCH_YEAR = 'fetch-year',
  FIELD_MONTH = 'field-month',
  FIELD_TIME_COURSE = 'field-time-course',
  FIELD_YEAR = 'field-year',
  LAYOUT_INITIAL = 'layout-initial',
  MAPPER_MONTH = 'mapper-month',
  MAPPER_TIME_COURSE = 'mapper-time-course',
  MAPPER_YEAR = 'mapper-year',
  PANEL_0 = 'panel-0',
  PANEL_FILTER = 'panel-filter',
  PANEL_ROOT = 'panel-root',
  PANEL_TOKENS = 'panel-tokens',
  TABLE_COLUMN_ACTION = 'table-column-action',
  TABLE_COLUMN_ANO = 'table-column-ano',
  TABLE_COLUMN_DELAYS = 'table-column-delays',
  TABLE_COLUMN_MONTH = 'table-column-month',
  TABLE_COLUMN_OS_TIME = 'table-column-os-time',
  TABLE_COLUMN_RESOLUTION_TIME = 'table-column-resolution-time',
  TABLE_COLUMN_SLA_RECEIVED = 'table-column-sla-received',
  TABLE_COLUMN_TYPE_SLA = 'table-column-type-sla',
  TABLE_RESOLUTION_TIME_BY_MONTH = 'table-resolution-time-by-month',
  TEXT_MONTH = 'text-month',
  TEXT_TIME_COURSE = 'text-time-course',
  TEXT_YEAR = 'text-year',
  TOKEN_SLA_REACHED = 'token-sla-reached',
  TOKEN_SLA_TARGET = 'token-sla-target',
}
export { SlaGraphicAliases };
